export const SetUpAProgramCardTitle = "1. Set up a subscription program";
export const SUB_MODAL_DEMO_TITLE = "Create a demo program";
export const SUB_MODAL_TITLE = "Create your own program";
export const SUBSCRIPTION_SET_UP_TITLE = "Subscription setup";
